export const SewingPermissions = {
  "General Manager": [],
  "Asst. General Manager": [],
  Manager: [
    {
      path: "/sewing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sewing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/sewing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sewing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],

  "Sewing Incharge": [
    {
      path: "/sewing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sewing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],

  Incharge: [
    {
      path: "/sewing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sewing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],

  Executive: [
    {
      path: "/sewing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sewing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
};
